// extracted by mini-css-extract-plugin
export default {"cls1":"CitationModal-cls1__c6f31a139a555a7f214f","cls2":"CitationModal-cls2___570c7df2c9b9f97e5b4 CitationModal-cls1__c6f31a139a555a7f214f"};